import * as XLSX from "xlsx";
export const handleOverlappingTigersExport = (
  selectedYear,
  selectedGender,
  getGenderLabel,
  overlapData
) => {
  const exportData = [];

  exportData.push({
    "Main Tiger": "Tiger Territory Overlap Analysis",
    "Overlapping Tiger": `Year: ${selectedYear}`,
    "Area (m²)": `Gender: ${getGenderLabel(selectedGender)}`,
    "Overlap Percentage (%)": `Generated on: ${new Date().toLocaleDateString()}`,
    "Total Overlaps": "",
  });

  // empty row for separation
  exportData.push({
    "Main Tiger": "",
    "Overlapping Tiger": "",
    "Area (m²)": "",
    "Overlap Percentage (%)": "",
    "Total Overlaps": "",
  });

  // column headers
  exportData.push({
    "Main Tiger": "Main Tiger",
    "Overlapping Tiger": "Overlapping Tiger",
    "Area (m²)": "Area (m²)",
    "Overlap Percentage (%)": "Overlap Percentage (%)",
    "Total Overlaps": "Total Overlaps",
  });

  Object.entries(overlapData).forEach(([mainTiger, overlaps]) => {
    if (overlaps.length === 0) {
      // If no overlaps, add a single row
      exportData.push({
        "Main Tiger": mainTiger,
        "Overlapping Tiger": "No overlaps",
        "Area (m²)": 0,
        "Overlap Percentage (%)": 0,
        "Total Overlaps": 0,
      });
    } else {
      // each overlap as a separate row
      overlaps.forEach((overlap, index) => {
        exportData.push({
          "Main Tiger": index === 0 ? mainTiger : "", // Only show main tiger name on first row
          "Overlapping Tiger": overlap.tiger,
          "Area (m²)": overlap.area_m2,
          "Overlap Percentage (%)": overlap.percent,
          "Total Overlaps": index === 0 ? overlaps.length : "", // Only show total on first row
        });
      });

      // separator row between different main tigers
      exportData.push({
        "Main Tiger": "",
        "Overlapping Tiger": "",
        "Area (m²)": "",
        "Overlap Percentage (%)": "",
        "Total Overlaps": "",
      });
    }
  });

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(exportData);

  const colWidths = [
    { wch: 20 }, // Main Tiger
    { wch: 20 }, // Overlapping Tiger
    { wch: 15 }, // Area (m²)
    { wch: 20 }, // Overlap Percentage (%)
    { wch: 15 }, // Total Overlaps
  ];
  ws["!cols"] = colWidths;

  for (let i = 0; i < 3; i++) {
    const rowCells = ["A", "B", "C", "D", "E"];
    rowCells.forEach((col) => {
      const cellRef = col + (i + 1);
      if (ws[cellRef]) {
        ws[cellRef].s = {
          font: { bold: true },
          fill: { fgColor: { rgb: "E6E6E6" } },
        };
      }
    });
  }

  XLSX.utils.book_append_sheet(wb, ws, "Tiger Territory Overlaps");

  const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-");
  const filename = `Tiger_Territory_Overlaps_${selectedYear}_${selectedGender}_${timestamp}.xlsx`;

  XLSX.writeFile(wb, filename);
};
